<button
  type="button"
  class="{{ getStyling() }}"
  [disabled]="disabled"
  (click)="handleOnClick($event)"
>
  <ng-container *ngIf="label">{{ label }}</ng-container>
  <ng-container *ngIf="!label"><ng-content></ng-content></ng-container>
</button>
